<blockable-div id="shift-turnover-details-container" #turnover>
  <app-progress-spinner [enabled]="!shiftTurnover" />
  <p-blockUI
    [blocked]="saving === true || loading === true"
    [target]="turnover"
  />
  @if (form) {
    <form
      [formGroup]="form"
      class="crm-shift-form"
      id="shiftturnover-create-form"
    >
      <div class="xtra-small-top-padding" id="contact-action-buttons">
        <div class="no-padding-top-bottom button-header">
          @if (shiftTurnover?.id && shouldShowEditSaveButtons()) {
            <div
              class="button-wrapper no-padding-top-bottom"
              style="display: flex; align-items: center"
            >
              <span
                style="font-weight: 700; text-align: right; margin-right: 8px"
                >{{ 'COMMON.LABEL.ACTIONS' | translate }}:</span
              >
              <span
                class="no-padding-top-bottom"
                style="text-align: left !important"
              >
                <p-select
                  [options]="actions"
                  (onChange)="actionEvent($event, dd)"
                  [(ngModel)]="selectedAction"
                  [ngModelOptions]="{ standalone: true }"
                  styleclass="action-drop-down"
                  scrollHeight="calc(100vh-35vh)"
                  #dd
                />
              </span>
            </div>
          }
          @if (isEditting === false && shouldShowEditSaveButtons()) {
            <div class="button-wrapper no-padding-top-bottom">
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.EDIT' | translate }}"
                icon="fa fa-fw fa-edit"
                (click)="setEditting()"
              ></button>
              <button
                pButton
                icon="fa fa-fw fa-refresh"
                (click)="refresh()"
              ></button>
            </div>
          }
          @if (isEditting === true && shouldShowEditSaveButtons()) {
            <div class="button-wrapper no-padding-top-bottom ui-inputgroup">
              <button
                pButton
                class="width-eighty"
                label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                icon="fa fa-fw fa-save"
                [disabled]="!this.form.valid || this.saving"
                (click)="saveShiftTurnover()"
              ></button>
              <button
                pButton
                class="refresh-button width-twenty"
                icon="fa fa-fw fa-refresh"
                (click)="refresh()"
              ></button>
            </div>
          }
          <div>
            <app-progress-spinner [enabled]="saving" />
          </div>
        </div>
      </div>
      <div class="no-padding">
        <div class="no-padding-top-bottom row">
          <div class="row-item no-padding-top-bottom">
            <span class="row-label label"
              >{{ 'CRM.LABEL.SHIFT_CHANGE' | translate }}:</span
            >
            <span class="row-input">
              <p-select [options]="shiftTypes" formControlName="shiftType" />
            </span>
          </div>
          <div class="row-item no-padding-top-bottom">
            <span class="row-label label"
              >{{ 'CRM.LABEL.AOR' | translate }}:</span
            >
            <span class="row-input">
              <p-select
                [options]="crmDistricts"
                (onChange)="aorChange($event)"
                formControlName="aor"
              />
            </span>
          </div>
          <div class="row-item no-padding-top-bottom">
            <span class="row-label label"
              >{{ 'CRM.LABEL.CREATED_DATE' | translate }}:</span
            >
            <span class="row-input">
              <p-datepicker
                formControlName="createdDt"
                [showTime]="true"
                [showSeconds]="true"
                hourFormat="12"
              />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="row-item no-padding-top-bottom">
            <span class="row-label label"
              >{{ 'CRM.LABEL.TURNOVER_DATE' | translate }}:</span
            >
            <span class="row-input">
              <p-datepicker formControlName="shiftDate" />
            </span>
          </div>
          <div class="row-item no-padding-top-bottom">
            <span class="row-label label"
              >{{ 'CRM.LABEL.STATUS' | translate }}:</span
            >
            <span class="row-input">
              <input pInputText formControlName="status" />
            </span>
          </div>
          <div class="row-item">
            @if (shiftTurnover?.departingCompletedDate) {
              <span class="row-label label"
                >{{ 'CRM.LABEL.DEPARTING_COMPLETED_DATE' | translate }}:</span
              >
              <span class="row-input">
                <p-datepicker
                  formControlName="departingCompleted"
                  [showTime]="true"
                  [showSeconds]="true"
                  hourFormat="12"
                />
              </span>
            }
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <span class="row-label label"
              >{{ 'CRM.LABEL.DEPARTING_ANALYST' | translate }}:</span
            >
            <span class="row-input">
              <p-autoComplete
                [suggestions]="filteredContacts"
                formControlName="departingAnalyst"
                [dropdown]="true"
                optionLabel="fullName"
                (completeMethod)="contactSearch($event)"
                appendTo="body"
                [forceSelection]="true"
              />
            </span>
          </div>
          <div class="row-item">
            <span class="row-label label"
              >{{ 'CRM.LABEL.INCOMING_ANALYST' | translate }}:</span
            >
            <span class="row-input">
              <p-autoComplete
                [suggestions]="filteredContacts"
                formControlName="incomingAnalyst"
                [dropdown]="true"
                optionLabel="fullName"
                (completeMethod)="contactSearch($event)"
                appendTo="body"
                [forceSelection]="true"
              />
            </span>
          </div>
          @if (isOptimizationAor()) {
            <div class="row-item">
              <span class="row-label label"
                >{{ 'CRM.LABEL.SECOND_INCOMING_ANALYST' | translate }}:</span
              >
              <span class="row-input">
                <p-autoComplete
                  [suggestions]="filteredContacts"
                  formControlName="secondaryIncomingAnalyst"
                  [dropdown]="true"
                  optionLabel="fullName"
                  (completeMethod)="contactSearch($event)"
                  appendTo="body"
                  [forceSelection]="true"
                />
              </span>
            </div>
          }
          <div class="row-item">
            @if (shiftTurnover?.incomingCompletedDate) {
              <span class="row-label label"
                >{{ 'CRM.LABEL.INCOMING_COMPLETED_DATE' | translate }}:</span
              >
              <span class="row-input">
                <p-datepicker
                  formControlName="incomingCompleted"
                  [showTime]="true"
                  [showSeconds]="true"
                  hourFormat="12"
                />
              </span>
            }
          </div>
        </div>
        <!-- Departing/Incoming Toggle Section: START -->
        @if (shiftTurnover?.ShiftDetails?.length ?? 0 > 0) {
          <header>{{ 'CRM.LABEL.DEPARTING_ANALYST' | translate }}</header>
          <section class="departing">
            <div class="no-padding-top-bottom departing-incoming-form">
              @for (
                item of getChildControls('items');
                track item;
                let j = $index
              ) {
                <div
                  class="no-padding-top-bottom form-row"
                  formArrayName="items"
                >
                  <div formGroupName="{{ j }}" class="form-row">
                    <div
                      class="no-padding-top-bottom form-area"
                      style="font-weight: 700"
                    >
                      {{ item.get('name')?.value }}:
                    </div>
                    <div class="form-area-comments">
                      <div>
                        <p-toggleButton
                          onLabel="Yes"
                          offLabel="No"
                          formControlName="departingTurnoverFlag"
                        />
                      </div>
                      <div class="input-field">
                        <textarea
                          pTextarea
                          autoResize="autoResize"
                          formControlName="departingComments"
                          [rows]="2"
                          [cols]="textAreaSize"
                        ></textarea>
                        <app-inline-validation
                          field="departingComments"
                          [control]="getItemFormChild(j, 'departingComments')"
                          [validationMessages]="validationMessages"
                          [validationParams]="validationParams"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="form-row">
                <div
                  class="no-padding-top-bottom form-area"
                  style="font-weight: 700"
                  [translate]="'CRM.LABEL.ADDITIONAL_COMMENTS'"
                ></div>
                <div class="input-field form-area-comments">
                  <textarea
                    pTextarea
                    autoResize="autoResize"
                    formControlName="departingAdditionalComments"
                    [rows]="2"
                    [cols]="commentsTextAreaSize"
                  ></textarea>
                  <app-inline-validation
                    field="departingAdditionalComments"
                    [control]="getBaseFormChild('departingAdditionalComments')"
                    [validationMessages]="validationMessages"
                    [validationParams]="validationParams"
                  />
                </div>
              </div>
            </div>
            @if (canViewDeparting) {
              <div class="departing-questions">
                <div class="question-group">
                  <span
                    class="question-label"
                    [translate]="'CRM.LABEL.PREPARED_TO_LOG_OFF_SCADA'"
                  >
                  </span>
                  <span class="no-padding-top-bottom">
                    <p-toggleButton
                      onLabel="Yes"
                      offLabel="No"
                      formControlName="departingScadaFlag"
                    />
                  </span>
                </div>
                <div class="question-group">
                  <span
                    class="question-label"
                    [translate]="'CRM.LABEL.FIT_TO_DRIVE'"
                  >
                  </span>
                  <span class="no-padding-top-bottom">
                    <p-toggleButton
                      onLabel="Yes"
                      offLabel="No"
                      formControlName="departingFitFlag"
                    />
                  </span>
                </div>
                <div class="question-group-large">
                  <span
                    class="question-label"
                    [translate]="'CRM.LABEL.FATIGUE_MITIGATIONS'"
                  >
                  </span>
                  <div class="buttons">
                    @for (
                      item of getChildControls('mitigations');
                      track item;
                      let j = $index
                    ) {
                      <span class="button" formArrayName="mitigations">
                        <span formGroupName="{{ j }}" class="button">
                          <span class="button-label">{{
                            item.get('mitigationName')?.value
                          }}</span>
                          <span class="toggle">
                            <p-toggleButton
                              onLabel="Yes"
                              offLabel="No"
                              formControlName="turnoverFlag"
                            />
                          </span>
                        </span>
                      </span>
                    }
                  </div>
                </div>
              </div>
            }
          </section>
        }
        <!-- Departing/Incoming Toggle Section: END -->
      </div>
      @if (
        (shiftTurnover?.ShiftDetails?.length ?? 0 > 0) &&
        shiftTurnover?.status !== 'N' &&
        canViewIncoming
      ) {
        <header>{{ 'CRM.LABEL.INCOMING_ANALYST' | translate }}</header>
        <section class="incoming-section">
          @if (shiftTurnover?.departingCompletedDate) {
            <section>
              <label>{{ 'CRM.LABEL.UNACKNOWLEDGED_MOCS' | translate }}</label>
              <div class="no-padding-sides">
                <app-general-grid
                  [values]="unacknowledged"
                  [columns]="mocColumns"
                  [rows]="50"
                  [filterable]="true"
                  [screenName]="screenName"
                  [lazy]="false"
                  (changeViewEvent)="goToMocEvent($event)"
                  [includeExportCSV]="false"
                  [usePaginator]="false"
                  [rowsPerPageOptions]="[10, 20, 50]"
                  [alwaysShowPaginator]="false"
                  #grid
                />
              </div>
            </section>
            <section>
              <label>{{
                'CRM.LABEL.ACKNOW_AND_UPCOMING_MOCS' | translate
              }}</label>
              <div class="no-padding-sides">
                <app-general-grid
                  [values]="acknowledgedAndUpcoming"
                  [columns]="mocColumns"
                  [rows]="50"
                  [filterable]="false"
                  [screenName]="screenName"
                  [lazy]="false"
                  (changeViewEvent)="goToMocEvent($event)"
                  [includeExportCSV]="false"
                  [usePaginator]="false"
                  [rowsPerPageOptions]="[10, 20, 50]"
                  [alwaysShowPaginator]="false"
                  #grid
                />
              </div>
            </section>
            <section>
              <label>{{ 'CRM.LABEL.CONTROLLER_NOTES' | translate }}</label>
              <div class="no-padding-sides">
                <app-general-grid
                  [values]="turnoverNotes"
                  [columns]="noteColumns"
                  [rows]="50"
                  [totalRecords]="noteTotalRecords"
                  [filterable]="false"
                  [screenName]="screenName"
                  [lazy]="false"
                  (changeViewEvent)="openControllerNote($event)"
                  [includeExportCSV]="false"
                  [usePaginator]="false"
                  [rowsPerPageOptions]="[10, 20, 50]"
                  [alwaysShowPaginator]="false"
                  #grid
                />
              </div>
            </section>
          }
          @if (shiftTurnover?.AOR && shiftTurnover?.departingCompletedDate) {
            <section>
              <div class="dop-button">
                <button pButton (click)="onViewDopClick()">
                  {{ 'DOP.LABEL.BUTTONS.VIEW_DOP' | translate }}
                </button>
              </div>
            </section>
          }
          <div class="questions">
            <div class="question-group">
              <span
                class="question-label"
                [translate]="'CRM.LABEL.PREPARED_TO_LOG_ONTO_SCADA'"
              >
              </span>
              <span class="no-padding-top-bottom">
                <p-toggleButton
                  onLabel="Yes"
                  offLabel="No"
                  formControlName="incomingScadaFlag"
                />
              </span>
            </div>
            <div class="question-group">
              <span
                class="question-label"
                [translate]="'CRM.LABEL.FIT_TO_WORK'"
              >
              </span>
              <span class="no-padding-top-bottom">
                <p-toggleButton
                  onLabel="Yes"
                  offLabel="No"
                  formControlName="incomingFitFlag"
                />
              </span>
            </div>
            <div class="question-group">
              <span
                class="question-label"
                [translate]="'CRM.LABEL.REVIEWED_ITEMS_WITH_DEPARTING'"
              >
              </span>
              <span class="no-padding-top-bottom">
                <p-toggleButton
                  onLabel="Yes"
                  offLabel="No"
                  formControlName="incomingReviewedAllSections"
                />
              </span>
            </div>
            <div class="input-field form-area question-group">
              <span
                class="question-label"
                [translate]="'CRM.LABEL.ADDITIONAL_COMMENTS'"
              >
              </span>
              <textarea
                pTextarea
                formControlName="incomingAdditionalComments"
                autoResize="autoResize"
                [rows]="2"
                [cols]="commentsTextAreaSize"
              ></textarea>
              <app-inline-validation
                field="incomingAdditionalComments"
                [control]="getBaseFormChild('incomingAdditionalComments')"
                [validationMessages]="validationMessages"
                [validationParams]="validationParams"
              />
            </div>
          </div>

          @if (
            isOptimizationAor() && form.get('secondaryIncomingAnalyst')?.value
          ) {
            <!-- Optional Second Incoming -->
            <hr />
            <h3 class="second-incoming-label">
              {{ 'CRM.LABEL.SECOND_INCOMING_ANALYST' | translate }}
            </h3>
            <div class="questions">
              <div class="question-group">
                <span
                  class="question-label"
                  [translate]="'CRM.LABEL.PREPARED_TO_LOG_ONTO_SCADA'"
                >
                </span>
                <span class="no-padding-top-bottom">
                  <p-toggleButton
                    onLabel="Yes"
                    offLabel="No"
                    formControlName="secondIncomingScadaFlag"
                  />
                </span>
              </div>
              <div class="question-group">
                <span
                  class="question-label"
                  [translate]="'CRM.LABEL.FIT_TO_WORK'"
                >
                </span>
                <span class="no-padding-top-bottom">
                  <p-toggleButton
                    onLabel="Yes"
                    offLabel="No"
                    formControlName="secondIncomingFitFlag"
                  />
                </span>
              </div>
              <div class="question-group">
                <span
                  class="question-label"
                  [translate]="'CRM.LABEL.REVIEWED_ITEMS_WITH_DEPARTING'"
                >
                </span>
                <span class="no-padding-top-bottom">
                  <p-toggleButton
                    onLabel="Yes"
                    offLabel="No"
                    formControlName="secondIncomingReviewedAllSections"
                  />
                </span>
              </div>
              <div class="input-field form-area question-group">
                <span
                  class="question-label"
                  [translate]="'CRM.LABEL.ADDITIONAL_COMMENTS'"
                >
                </span>
                <textarea
                  pTextarea
                  formControlName="secondIncomingAdditionalComments"
                  autoResize="autoResize"
                  [rows]="2"
                  [cols]="commentsTextAreaSize"
                ></textarea>
                <app-inline-validation
                  field="secondIncomingAdditionalComments"
                  [control]="
                    getBaseFormChild('secondIncomingAdditionalComments')
                  "
                  [validationMessages]="validationMessages"
                  [validationParams]="validationParams"
                />
              </div>
            </div>
          }
        </section>
      }
    </form>
  }

  @if (shiftTurnover?.AOR) {
    <p-dialog
      header="{{ getHeaderForDopDialog() | async }}"
      [(visible)]="showDOPDialog"
      showEffect="fade"
      [modal]="true"
      [transitionOptions]="'0ms'"
      [style]="{ width: '1250px' }"
      class="dop-dialog"
    >
      @if (!dopWorking()) {
        <div class="aor-container">
          <div class="aor-title">{{ shiftTurnover?.AOR?.name }}</div>
          <div class="sub-systems-container">
            <div class="sub-systems-item">
              <div class="sub-system-title">
                <div>{{ shiftTurnover?.AOR?.name }}:</div>
              </div>
              <p-scrollPanel class="dop-entries-scroll-panel">
                @for (
                  entry of getMatchingEntriesForAor(
                    $safeNavigationMigration(shiftTurnover?.AOR?.id)
                  );
                  track $index
                ) {
                  <app-log-entry [entry]="entry" />
                }
              </p-scrollPanel>
            </div>

            @for (
              subSystem of shiftTurnover?.AOR?.aorSubSystems;
              track $index
            ) {
              <div class="sub-systems-item">
                <div class="sub-system-title">
                  <div>{{ subSystem.name }}:</div>
                </div>
                <p-scrollPanel class="dop-entries-scroll-panel">
                  @for (
                    entry of getMatchingEntriesForAorSubSystem(subSystem.id);
                    track $index
                  ) {
                    <app-log-entry [entry]="entry" />
                  }
                </p-scrollPanel>
              </div>
            }
          </div>
          <button
            pButton
            class="acknowledge-button"
            (click)="onAcknowledgeDopClick()"
          >
            {{ 'DOP.LABEL.BUTTONS.ACKNOWLEDGE_DOP' | translate }}
          </button>
        </div>
      } @else {
        <app-progress-spinner [enabled]="dopWorking()" />
      }
    </p-dialog>
  }
</blockable-div>
